'use client';
import Link from "next/link";
import { RotatingText } from "./rotating-text";
import { Button } from "./ui/button";
import { Logo } from "./logo";
import { Balancer } from 'react-wrap-balancer'

export default function Hero() {
  return (
    <section className="container mx-auto px-4 py-16 md:py-24 text-center">
      <div className="max-w-3xl mx-auto space-y-8">
        <div className="flex justify-center mb-6">
          <Logo size={80} />
        </div>
        <h1 className="text-5xl md:text-6xl tracking-tight">
          Design Database Schemas. Let AI Extract the Data.
        </h1>

        <div className="space-y-4">
          <p className="text-lg l mx-auto">
            <Balancer ratio={1}>            Build tables in our visual editor. Define fields with prompts like
              <span className="font-mono text-sm bg-muted px-2 py-1 rounded">invoice_total → "The total amount due"</span>.
              AI extracts structured, relational data into SQLite—not bloated JSON dumps.
            </Balancer>
          </p>
        </div>

        <div>
          <Button size="lg" className="px-8 font-mono" asChild>
            <Link href={"/create-account"}>
              BUILD YOUR SCHEMA
            </Link>
          </Button>
        </div>

        <ul className="space-y-2 text-sm text-left max-w-md mx-auto">
          <li className="flex items-start gap-2">
            <span>•</span>
            <span>Visual schema builder: Create tables and fields with AI prompts</span>
          </li>
          <li className="flex items-start gap-2">
            <span>•</span>
            <span>True relational data: Link child tables (line items → invoices) with foreign keys</span>
          </li>
          <li className="flex items-start gap-2">
            <span>•</span>
            <span>Built for LLM agents: Query SQLite with 10x fewer tokens than parsing JSON</span>
          </li>
          <li className="flex items-start gap-2">
            <span>•</span>
            <span>Export anywhere: CSV, JSON, XML from your relational database</span>
          </li>
        </ul>
      </div>
    </section>
  );
}
